import React, { useState, useEffect } from 'react';

const ServiceForm = ({ initialData, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    price: '',
    personalPrice: '',
    suvPrice: '',
    duration: '',
    description: '',
    features: []
  });

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFeatureChange = (index, value) => {
    const newFeatures = [...formData.features];
    newFeatures[index] = value;
    setFormData(prev => ({
      ...prev,
      features: newFeatures
    }));
  };

  const addFeature = () => {
    setFormData(prev => ({
      ...prev,
      features: [...prev.features, '']
    }));
  };

  const removeFeature = (index) => {
    setFormData(prev => ({
      ...prev,
      features: prev.features.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const processedData = {
      ...formData,
      duration: parseInt(formData.duration)
    };

    // Convert package prices to numbers if it's a package
    if (formData.category === 'Pakiety') {
      processedData.personalPrice = parseInt(formData.personalPrice);
      processedData.suvPrice = parseInt(formData.suvPrice);
      // Remove the regular price field for packages
      delete processedData.price;
    } else {
      // Remove package-specific prices for non-package services
      delete processedData.personalPrice;
      delete processedData.suvPrice;
    }

    onSubmit(processedData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-white mb-1">Tytuł usługi</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          className="w-full rounded-lg bg-white/10 border-gray-600 text-white"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-white mb-1">Kategoria</label>
        <select
          name="category"
          value={formData.category}
          onChange={handleChange}
          className="w-full rounded-lg bg-white/10 border-gray-600 text-white [&>option]:bg-gray-800 [&>option]:text-white"
          required
        >
          <option value="">Wybierz kategorię</option>
          <option value="Mycie zewnętrzne">Mycie zewnętrzne</option>
          <option value="Wnętrze">Wnętrze</option>
          <option value="Detailing">Detailing</option>
          <option value="Pakiety">Pakiety</option>
        </select>
      </div>

      {formData.category === 'Pakiety' ? (
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-white mb-1">Cena - Auto osobowe</label>
            <input
              type="number"
              name="personalPrice"
              value={formData.personalPrice}
              onChange={handleChange}
              className="w-full rounded-lg bg-white/10 border-gray-600 text-white"
              required
              min="0"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-white mb-1">Cena - SUV/Van</label>
            <input
              type="number"
              name="suvPrice"
              value={formData.suvPrice}
              onChange={handleChange}
              className="w-full rounded-lg bg-white/10 border-gray-600 text-white"
              required
              min="0"
            />
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-white mb-1">Cena</label>
            <input
              type="text"
              name="price"
              value={formData.price}
              onChange={handleChange}
              className="w-full rounded-lg bg-white/10 border-gray-600 text-white"
              required
              placeholder="np. 100, 70-100, 15 zł/szt, od 300"
            />
          </div>
          <div className="opacity-0">
            {/* Placeholder div to maintain grid layout */}
          </div>
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-white mb-1">Czas trwania (min)</label>
        <input
          type="number"
          name="duration"
          value={formData.duration}
          onChange={handleChange}
          className="w-full rounded-lg bg-white/10 border-gray-600 text-white"
          required
          min="0"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-white mb-1">Opis</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="w-full rounded-lg bg-white/10 border-gray-600 text-white"
          rows="3"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-white mb-2">Cechy usługi</label>
        {(formData.features || []).map((feature, index) => (
          <div key={index} className="flex mb-2">
            <input
              type="text"
              value={feature}
              onChange={(e) => handleFeatureChange(index, e.target.value)}
              className="flex-1 rounded-lg bg-white/10 border-gray-600 text-white"
            />
            <button
              type="button"
              onClick={() => removeFeature(index)}
              className="ml-2 px-2 py-1 bg-red-500/20 hover:bg-red-500/30 text-white rounded-md"
            >
              Usuń
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={addFeature}
          className="text-sm text-primary-400 hover:text-primary-300"
        >
          + Dodaj cechę
        </button>
      </div>

      <div className="flex justify-end space-x-4 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 bg-gray-500/20 hover:bg-gray-500/30 text-white rounded-md"
        >
          Anuluj
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-primary-500/20 hover:bg-primary-500/30 text-white rounded-md"
        >
          {initialData ? 'Zapisz zmiany' : 'Dodaj usługę'}
        </button>
      </div>
    </form>
  );
};

export default ServiceForm;
